import React from 'react';
import { createPortal } from 'react-dom';
import './SafetyReportPrint.css';

function SafetyReportConclusionModal({ show, onClose, project, modalSummary }) {
  if (!show || !project) return null;

  const projName = project.name || '-';
  const projWriter = project.write_name || project.manager_name || project.writeName || '-';
  const projWriterDate = project.created_at ? project.created_at.split('T')[0] : '-';

  const summaryData = modalSummary || {};

  const handlePrint = () => {
    const printContent = document.getElementById('conclusion-printable-area');
    if (!printContent) return;

    const printWindow = window.open('', '_blank', 'width=1000,height=900');
    if (!printWindow) {
      alert('팝업 차단이 설정되어 있습니다. 브라우저 팝업 차단을 해제한 후 다시 시도해주세요.');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>위험성평가 종합 총평 출력</title>
          <style>
            @media print {
              @page { size: A4; margin: 12mm; }
              body { padding: 0 !important; background: #ffffff !important; color: #000000 !important; font-family: Pretendard, -apple-system, sans-serif; }
              .no-print { display: none !important; }
            }
            body { padding: 25px; background: #ffffff; color: #000000; font-family: Pretendard, -apple-system, sans-serif; line-height: 1.5; }
            .no-print { display: none !important; }
            table { width: 100% !important; border-collapse: collapse !important; margin-bottom: 1.5rem; }
            th, td { border: 1px solid #dee2e6; padding: 0.75rem; vertical-align: middle; }
            .text-center { text-align: center; } .fw-bold { font-weight: bold; }
            .bg-light, .table-light { background-color: #f8fafc !important; }
            .text-primary { color: #0d6efd; } .text-success { color: #198754; } .text-muted { color: #6c757d; }
            .text-dark { color: #212529; } .text-white { color: #fff; }
            .d-flex { display: flex; } .justify-content-between { justify-content: space-between; } .justify-content-end { justify-content: flex-end; } .align-items-center { align-items: center; }
            .gap-1\\.5 { gap: 0.375rem; } .gap-2 { gap: 0.5rem; }
            .border-bottom { border-bottom: 1px solid #dee2e6; } .border-top { border-top: 1px solid #dee2e6; } .border { border: 1px solid #dee2e6; }
            .rounded-3 { border-radius: 0.5rem; }
            .badge { display: inline-block; padding: 0.35em 0.65em; font-size: 0.75em; font-weight: 700; text-align: center; border-radius: 0.25rem; color: #fff; }
            .bg-secondary { background-color: #6c757d; } .bg-success-subtle { background-color: #d1e7dd; color: #0f5132; } .bg-success { background-color: #198754; }
            .mb-0 { margin-bottom: 0; } .mb-2 { margin-bottom: 0.5rem; } .mb-3 { margin-bottom: 1rem; } .mb-4 { margin-bottom: 1.5rem; }
            .pt-1 { padding-top: 0.25rem; } .pb-1 { padding-bottom: 0.25rem; } .pb-2 { padding-bottom: 0.5rem; }
            .p-3 { padding: 1rem; } .px-3 { padding-left: 1rem; padding-right: 1rem; }
            .small { font-size: 0.875em; } .fs-6 { font-size: 1rem; }
          </style>
        </head>
        <body>
          <div>
            ${printContent.innerHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return createPortal(
    <div
      className="report-viewer-overlay"
      style={{
        zIndex: 999999,
        background: 'rgba(15, 23, 42, 0.75)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3 shadow-lg border-0 overflow-hidden"
        style={{ width: '100%', maxWidth: '980px', maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="text-dark px-4 d-flex justify-content-between align-items-center no-print border-bottom" style={{ backgroundColor: '#e2e8f0', minHeight: '58px' }}>
          <div className="d-flex align-items-center gap-2" style={{ maxWidth: '90%' }}>
            <h5 className="fw-bold mb-0 text-dark text-truncate" style={{ fontSize: '1.15rem' }} title={`[총평] ${projName}`}>
              [총평] {projName}
            </h5>
          </div>
        </div>

        <style>{`
          .editor-content-box { padding-top: 0.5rem !important; line-height: 1.5 !important; }
          .editor-content-box > *:first-child { margin-top: 0 !important; }
          .editor-content-box p:first-child { margin-top: 0 !important; }
          .editor-content-box p { margin-top: 0 !important; margin-bottom: 0.5rem !important; }
          .editor-content-box p:last-child { margin-bottom: 0 !important; }
        `}</style>

        <div className="p-4 bg-white text-dark overflow-auto" id="conclusion-printable-area" style={{ flex: 1, fontFamily: 'Pretendard, sans-serif' }}>
          <div className="px-3 pt-1 pb-1">
            <div className="text-center mb-4 border-bottom pb-3">
              <span className="badge bg-secondary mb-2 px-3 py-1 small">위험성평가 실시 결과 보고 대장</span>
              <h2 className="fw-bold mb-2" style={{ fontSize: '1.75rem', color: '#0f172a' }}>위험성평가 종합 총평</h2>
              <p className="text-muted m-0" style={{ fontSize: '0.9rem' }}>프로젝트별 위험성평가 실시 종합 결과 및 평가</p>
            </div>

            <table className="table table-bordered align-middle" style={{ width: '100%', fontSize: '14px', marginBottom: '20px' }}>
              <tbody>
                <tr>
                  <th style={{ width: '15%', background: '#f8fafc', padding: '12px 10px', textAlign: 'center', fontWeight: 'bold' }}>작성자</th>
                  <td style={{ width: '35%', padding: '12px 10px', textAlign: 'left', fontWeight: 'bold', color: '#1e293b' }}>
                    {summaryData.writer || project.manager_name || projWriter || '-'}
                  </td>
                  <th style={{ width: '15%', background: '#f8fafc', padding: '12px 10px', textAlign: 'center', fontWeight: 'bold' }}>작성일</th>
                  <td style={{ width: '35%', padding: '12px 10px', textAlign: 'left', fontWeight: 'bold', color: '#1e293b' }}>
                    {summaryData.writeDate || projWriterDate || '-'}
                  </td>
                </tr>
                <tr>
                  <th style={{ background: '#f8fafc', padding: '15px 10px', textAlign: 'center', fontWeight: 'bold', verticalAlign: 'top' }}>종합 총평</th>
                  <td colSpan={3} className="text-start align-top-content editor-content-box" style={{ minHeight: '500px', height: '600px', padding: '20px', verticalAlign: 'top', color: '#0f172a' }} dangerouslySetInnerHTML={{ __html: summaryData.conclusion || '<div style="color: #94a3b8; font-style: italic;">등록된 총평이 없습니다.</div>' }} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="px-4 py-2 d-flex justify-content-end align-items-center gap-2 no-print border-top" style={{ backgroundColor: '#f1f5f9', minHeight: '63px' }}>
          <button type="button" className="btn btn-primary btn-sm fw-bold px-3.5 py-2 d-flex align-items-center gap-1.5" onClick={handlePrint}>
            <i className="bi bi-printer-fill"></i> 바로 인쇄 / PDF 저장
          </button>
          <button type="button" className="btn btn-dark btn-sm px-4 py-2" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default SafetyReportConclusionModal;
